<template>
  <b-container class="positions-list m-0 p-0">

    <!-- Table !-->
    <grid-view :toolbar="toolbar" primary="id" :columns="positionColumns" :rows="positionsList"></grid-view>

    <!-- Manage positions form !-->
    <b-modal id="updatePos" title="Update position" :hide-footer="true" no-close-on-backdrop>

      <b-form @submit="savePosition">

        <!-- Email address !-->
        <b-form-group label="Position:" description="Describe position.">

          <select-box :options="wsPositionsOptions" v-model="position.workspace_position_id" required/>

          <!--b-form-input v-model="position.title" type="text" required
                        placeholder="Enter position"></b-form-input!-->
        </b-form-group>

        <ul>
          <li v-for="(usr, k) in position.users" :key="k">
            <a href="#" @click="removeUserFromPos(position, usr)">{{ usr.first_name }}</a>
          </li>
        </ul>

        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button type="button" variant="danger" @click="$bvModal.hide('updatePos')">Close</b-button>
      </b-form>

    </b-modal>

    <!-- Manage users form !-->
    <b-modal id="updateUserPos" title="Update user on position" :hide-footer="true" no-close-on-backdrop>
      <b-form @submit="addUserPosition">

        <!-- Email address !-->
        <b-form-group label="Choose user from the team" description="Choose user to assign on the position">
          <select-box :options="usersList" v-model="assignUserId"/>
        </b-form-group>

        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button type="button" variant="danger" @click="$bvModal.hide('updateUserPos')">Close</b-button>
      </b-form>
    </b-modal>

  </b-container>
</template>

<script>

// Import grid view
import GridView from "../components/GridView";
import {toast} from "../utils/toast";
import {api} from '../utils/api'
import SelectBox from "../components/SelectBox";

/**
 * Positions object
 */
export default {

  // Components
  components: {SelectBox, GridView},

  // Properties
  props: ["task_id"],

  // On create
  created() {

  },

  // Component creation event
  mounted() {
    // load all positions
    this.$dispatch('positions/loadPositions', this.task_id).then(() => {
      this.$dispatch('wsusers/loadTeam', this.task_id);
    })
  },

  // Data
  data() {
    return {

      assignUserId: false,

      selectedPositions: [],

      // Header
      positionColumns: {
        title: {title: "Position"},
        position_title: {title: "Position title", view: (el) => {
          const ps = this.$get('wspositions/getByID', el.workspace_position_id);
          return ps ? ps.position_title : "n/a"
          } },
        users: {title: "Users", view: this.renderUsersList}
      },

      // toolbar
      toolbar: {
        add: {title: "Add", method: this.add},
        update: {title: "Update", method: this.update},
        delete: {title: "Delete", method: this.delete, confirm: "Are you sure want to delete position?"},
        addtopos: {title: "Add user to position", method: this.addUserToPos, required: true}
      },

      position: {task_id: this.task_id}

    };
  },

  // Computed vars
  computed: {

    /**
     * Users list
     * @returns {*}
     */
    usersList() {

      // Get parent workspace
      const wsId = this.$get("tree/getParents", this.task_id).pop();

      // Return users list
      let optList = [];
      for(const usr of this.$get('wsusers/list', wsId)) {
        optList.push({id: usr.user_id, title: (usr.user_name) });
      }

      // Return list
      return optList;
    },


    /**
     * Positions options list
     */
    wsPositionsOptions() {
      // Return pos list
      let optList = [];
      for(const pos of this.wsPositionsList) {
        optList.push({id: pos.id, title: (pos.position_title) });
      }

      // Return list
      return optList;
    },


    /**
     * Workspace positions list
     * @returns {*}
     */
    wsPositionsList() {
      // Return users list
      return this.$get('wspositions/list', this.$get('tree/getWorkspace', this.task_id).id);
    },


    // Positions list
    positionsList() {

      // Return users list
      return this.$store.getters['positions/getPositionsList'](this.task_id); // this.$store.getters['tree/getTasksParents'](this.task_id)
    }
  },

  // Some methods
  methods:
      {
        /**
         * Customize label
         */

        userSelectLabel({first_name, second_name}) {
          // Return name
          return first_name + " " + second_name;
        },

        /**
         * Delete positions
         */
        delete(positions) {
          for (let us of positions) {
            // Delete user
            this.$dispatch('positions/delete', us);
          }
        },

        /**
         * Render users column
         */
        renderUsersList(row) {

          // Checking for users count
          if (!row.users) return '';

          // Collapse users
          let usList = row.users.map(u => {
            return u.first_name + " " + u.second_name
          });

          // Return users
          return (usList.join(", "));
        },

        /**
         * Update users
         */
        update(positions) {
          // Check
          // for users count
          if (!positions.length) {
            toast.notify(this, 'Info', "Please choose one record to update.");
            return;
          }

          // Set user
          this.position = api.unreact(positions[0]);

          // Show dialog
          this.$bvModal.show('updatePos');
        },

        /**
         * Add new user
         */
        add() {
          // Reset user
          this.position = {task_id: this.task_id, workspace_position_id: 0};

          // Show dialog
          this.$bvModal.show('updatePos');
        },

        /**
         * Add new user to the position
         */
        addUserToPos(positions) {

          // Reset mail value
          this.assignUserId = false;

          // Reset user
          this.selectedPositions = positions;

          // Show dialog
          this.$bvModal.show('updateUserPos');
        },

        /**
         * Remove user to the position
         */
        removeUserFromPos(position, user) {

          // Exit if not confirmed
          if (!confirm("Do you want to delete user from position?")) return;

          this.$dispatch('positions/deleteUserOnPos', {id: position.id, user_id: user.id}).then(() => {
            // Store user id into position
            position.users = position.users.filter(u => u.id != user.id);
          });
        },

        /**
         * Add user to the selected position
         */

        addUserPosition(evt) {

          // Prevent submit
          evt.preventDefault();

          // Process each item
          for (let sel of this.selectedPositions) {

            // Add new user
            this.$dispatch('positions/addUserToPos', {position_id: sel.id, user_id: this.assignUserId}).then(() => {

              // Show notification
              toast.notify(this, 'Info', "User was added.");

              // Hide dialog
              this.$bvModal.hide('updateUserPos');

            }).catch((res) => {

              // Show errors
              for (let i in res.errors) {
                let err = res.errors[i];
                toast.notify(this, 'Error', err, 'danger');
              }
            });
          }
        },

        /**
         * Save users
         * @param usr
         */
        savePosition(evt) {

          // Prevent submit
          evt.preventDefault();

          // Copy object
          let obj = api.unreact(this.position);

          // Fill object
          if (obj.users) obj.users = obj.users.map(usr => {
            return usr.id;
          });

          // Add new user
          this.$dispatch(this.position.id ? 'positions/update' : 'positions/register', obj).then(() => {

            // Show notification
            toast.notify(this, 'Info', "Position was added.");

            // Hide dialog
            this.$bvModal.hide('updatePos');

          }).catch((res) => {

            // Show errors
            for (let i in res.errors) {
              let err = res.errors[i];
              toast.notify(this, 'Error', err, 'danger');
            }
          });
        }
      }
}
</script>
